import { render, staticRenderFns } from "./WebViewer.vue?vue&type=template&id=b532db3c&scoped=true&"
import script from "./WebViewer.vue?vue&type=script&lang=js&"
export * from "./WebViewer.vue?vue&type=script&lang=js&"
import style0 from "./WebViewer.vue?vue&type=style&index=0&id=b532db3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b532db3c",
  null
  
)

export default component.exports